import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ISap } from '../models/requestModels'

export class PostSyncDealerApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sap/sync-dealer',
      requesterInfo,
    })
  }

  public async postSyncDealer(request: ISap): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
